<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/hr/payment-salary">
                    <icon name="money-check-alt"></icon>
                    คำนวณเงินเดือน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/rental-fee">
                    <icon name="home"></icon>
                    ข้อมูลเช่าบ้าน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/shopping">
                    <icon name="shopping-basket"></icon>
                    ค่าใช้จ่ายร้านค้า
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/advance-payment">
                    <icon name="credit-card"></icon>
                    เบิกล่วงหน้า
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "salary-payment"
    }
</script>

<style scoped>

</style>